import { useState } from "react";
import { useIsMobile } from "@/shared/hooks/use-mobile";
import { PanelLeftClose, PanelRightOpen } from "lucide-react";
import { cn } from "@/shared/lib/utils";
import { SidebarContent } from "./SidebarContent";
import {
  Sheet,
  SheetContent,
} from "@/shared/ui/sheet";

export function Sidebar() {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const isMobile = useIsMobile();

  const toggleSidebar = () => {
    setIsExpanded((prev) => !prev);
  };

  // Mobile: Use Sheet drawer
  if (isMobile) {
    return (
      <Sheet open={isMobileOpen} onOpenChange={setIsMobileOpen}>
        <SheetContent side="left" className="w-64 p-0">
          <SidebarContent isExpanded={true} />
        </SheetContent>
      </Sheet>
    );
  }

  // Desktop: Use fixed sidebar
  return (
    <div
      className={cn(
        "hidden md:flex h-full flex-col border-r bg-card transition-all duration-300",
        isExpanded ? "w-64" : "w-16"
      )}
    >
      <div className="flex h-16 items-center justify-between border-b px-4">
        {isExpanded && (
          <h2 className="text-lg font-semibold transition-opacity duration-300">
            Admin
          </h2>
        )}
        <button
          onClick={toggleSidebar}
          className="ml-auto rounded-md p-1.5 hover:bg-accent hover:text-accent-foreground transition-colors"
          aria-label={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          {isExpanded ? (
            <PanelLeftClose className="h-5 w-5" />
          ) : (
            <PanelRightOpen className="h-5 w-5" />
          )}
        </button>
      </div>
      <SidebarContent isExpanded={isExpanded} showTooltips={!isExpanded} />
    </div>
  );
}

// Export function to open mobile drawer (will be used by Header)
export function useSidebarMobile() {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  return { isMobileOpen, setIsMobileOpen };
}
